// /staff/list
import {
    POST,
    FormPost
} from "../util";
// 文件管理
// uploadFile: '/file/uploadFile',
// /api/fileupload/invoicedoc
const url = {
    file: {
        UploadFile: "/file/uploadFile",
        UploadVideo: "/file/uploadVideo",
        List: "/file/fileList"
    }
};
//订单管理

const file = {
    UploadFile: function UploadFile(params = {}) {
        return POST(url.file.UploadFile, params);
    },
    UploadVideo: function UploadVideo(params = {}) {
        return FormPost(url.file.UploadVideo, params);
    },
    List: function List(params = {}) {
        return POST(url.file.List, params);
    }
};

export {
    file
};